import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core"
import React from "react"
import { useTranslation } from "react-i18next"
import { BasicSearchConst } from "../BasicSearchConst"
import { Pressable, Text, View } from "react-native"
import { Permission, PulseOpsFormat, SourceType, TaskOp, TransactionLabel, TransactionStatus, TransactionStatusLabel, TransactionType } from "@pulseops/common"
import { DrawerContentComponentProps, DrawerContentOptions } from "@react-navigation/drawer"
import { TabSearch } from "../../service-inquiry/basic-search-form"
import { basicSharedStyles } from "../BasicSharedStyles"
type ClaimSearchTableProps = {
  rows: TaskOp[]
  roles: string[]
  selectedTab: TabSearch
  pageNum: number
  setPageNum: (pageNum: number) => void
  pageSize: number
  setPageSize: (pageSize: number) => void
  totalItem: number
  sortItem: { field: string; order: 'asc' | 'desc' | undefined }
  setSortItem: (sortItem: { field: string; order: 'asc' | 'desc' | undefined }) => void
  parentNavigation: DrawerContentComponentProps<DrawerContentOptions>
  queryServiceInquiryList: (pageSize: number, pageNum: number) => void
  claimTypeList: { label: string; value: string; codes: any[] }[]
}
export const ClaimSearchTable = (props: ClaimSearchTableProps) => {
  const { t } = useTranslation()
  const classes = BasicSearchConst.makeBasicStyles()
  const {
    rows,
    roles,
    selectedTab,
    pageNum,
    setPageNum,
    pageSize,
    setPageSize,
    totalItem,
    parentNavigation,
    queryServiceInquiryList,
    claimTypeList
  } = props
  return (
    <View style={basicSharedStyles.container}>
      <TableContainer component={Paper} style={{ maxHeight: 500 }} elevation={1}>
        <Table style={{ userSelect: 'text' }} stickyHeader>
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:CaseID')}</TableCell>

              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:ClaimNumber')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:ClaimType')}</TableCell>

              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Status')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:ClaimJourney')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:CurrentActivity')}</TableCell>
              {/* <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:LastAssignee')}</TableCell> */}
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:PolicyNumber')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:POClient')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:LAName')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:CreatedDate')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:UserSubmission')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:LastUpdatedDate')}</TableCell>
              {/* <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:LastUpdatedBy')}</TableCell> */}
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Aging')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Category')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Transaction')}</TableCell>
              <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Source')}</TableCell>
              <TableCell className={classes.tableCell} style={{ textAlign: 'center' }}>
                {t('ServiceInquiry:table:Note')}
              </TableCell>

              {/* <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:POID')}</TableCell> */}
              {/* <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Service')}</TableCell> */}
              {/* <TableCell className={classes.tableCell}>{t('ServiceInquiry:table:Group')}</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              return (
                <TableRow key={`TableRow-${i}`}>
                  {/* CaseID */}
                  <TableCell>
                    {row.caseId &&
                      roles.includes(Permission['ViewDetailServiceInquiry']) &&
                      (((row.source === SourceType.PULSE4OPS || row.source === SourceType.PRUONLINE) &&
                        row.transactionType !== TransactionType.UPLOAD_DOCUMENT) ||
                        (row.source === SourceType.PULSE &&
                          ((row.policyNumber.length === 9 &&
                            row.transactionType === TransactionType.NEW_CLAIM_REGISTER) ||
                            row.transactionType !==
                            (TransactionType.UPLOAD_DOCUMENT && TransactionType.NEW_CLAIM_REGISTER))) ||
                        (['EKIOSK', 'ZALO'].includes(row.source) && row.transactionType === 'COMPLAINT') ||
                        (row.source === 'LANDING_PAGE' && row.transactionType === 'SPECIAL_BONUS_CUSTOMER')) ? (
                      <Pressable
                        onPress={() =>
                          parentNavigation.navigation.navigate('TaskDetailStack', {
                            screen: 'TaskDetailScreen',
                            params: {
                              id: row.id,
                              caterogy: row.category,
                              basket: '',
                              basketName:
                                selectedTab === TabSearch.ClaimSearch
                                  ? row.transactionType === TransactionType.PAYOUT
                                    ? 'CL-PV'
                                    : row.status === TransactionStatus.IN_PROGRESS &&
                                      row.activity === '6. Verification'
                                      ? 'CL-VER'
                                      : 'CL-ADJ'
                                  : '',
                              isInquiry: '1',
                              isHistory: 'true',
                              isBreadcrumb: '1',
                              hasArchivedHistoryView: '1'
                            }
                          })
                        }
                      >
                        <Text style={[{ color: '#ed1b2e' }, basicSharedStyles.cellNoWrap]}>{row.caseId}</Text>
                      </Pressable>
                    ) : (
                      <Text style={basicSharedStyles.cellNoWrap}>{row.caseId || '-'}</Text>
                    )}
                  </TableCell>
                  {/* ClaimNumber */}
                  <TableCell>{row.claimNumber || '-'}</TableCell>
                  {/* ClaimType */}
                  <TableCell className={classes.cellNoWrap}>
                    {claimTypeList.find((x) => x.codes.find((_) => _.claimCode === row.claimType))?.label || '-'}
                  </TableCell>
                  {/* Status */}
                  <TableCell
                    style={{ color: TransactionStatusLabel(row.status).color }}
                    className={classes.cellNoWrap}
                  >
                    {TransactionStatusLabel(row.status).label}
                  </TableCell>
                  {/*Claim Journey */}
                  <TableCell>
                    {row.transactionType === TransactionType.NEW_CLAIM_REGISTER ? (
                      <Pressable
                        onPress={() =>
                          parentNavigation.navigation.navigate('TaskDetailStack', {
                            screen: 'TrackingStatusClaimScreen',
                            params: {
                              id: row.id,
                              sourceOfBusiness: row.policyNumber.length === 9 ? 'D' : 'T',
                              LAName: row.lifeAssuredName,
                              claimNumber: row.claimNumber,
                              policyNumber: row.policyNumber
                            }
                          })
                        }
                      >
                        <Text style={[{ color: '#1DA5FC' }, basicSharedStyles.cellNoWrap]}>
                          {t('ServiceInquiry:table:Detail')}
                        </Text>
                      </Pressable>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  {/* CurrentActivity */}
                  <TableCell>{row.activity || '-'}</TableCell>
                  {/* LastAssignee */}
                  {/* <TableCell>
                                      <Text>{row.assigneeName || '-'}</Text>
                                      {row.assignee && row.assignee !== '-' && (
                                        <View>
                                          <Text>({row.assignee.split('@')[0]})</Text>
                                        </View>
                                      )}
                                    </TableCell> */}
                  {/* PolicyNumber */}
                  <TableCell>{row.policyNumber || '-'}</TableCell>
                  {/* POClient */}
                  <TableCell>{row.clientNumber || '-'}</TableCell>
                  {/* LAName */}
                  <TableCell className={classes.cellNoWrap}>{row.lifeAssuredName || '-'}</TableCell>
                  {/* CreatedDate */}
                  <TableCell>{PulseOpsFormat.datetoFormat(row.createdDate, 'DD/MM/YYYY HH:mm:ss')}</TableCell>
                  {/* UserSubmission */}
                  <TableCell>{row.createdBy ? row.createdBy.split('@')[0] : '-'}</TableCell>
                  {/* LastUpdatedDate */}
                  <TableCell>
                    {row.lastUpdateDateAdj
                      ? PulseOpsFormat.datetoFormat(row.lastUpdateDateAdj, 'DD/MM/YYYY HH:mm:ss')
                      : row.lastUpdateDateVer
                        ? PulseOpsFormat.datetoFormat(row.lastUpdateDateVer, 'DD/MM/YYYY HH:mm:ss')
                        : '-'}
                  </TableCell>
                  {/* LastUpdatedBy */}
                  {/* <TableCell>
                                      {row.lastUpdateByAdj
                                        ? row.lastUpdateByAdj.split('@')[0]
                                        : row.lastUpdateByVer
                                        ? row.lastUpdateByVer.split('@')[0]
                                        : '-'}
                                    </TableCell> */}
                  {/* Aging */}
                  <TableCell>{row.aging}</TableCell>
                  {/* Category */}
                  <TableCell className={classes.cellNoWrap}>
                    {BasicSearchConst.convertCategoryToLabel(row.category) || '-'}
                  </TableCell>
                  {/* TransactionType */}
                  <TableCell className={classes.cellNoWrap}>
                    {t(TransactionLabel(row.transactionType))}
                  </TableCell>
                  {/* Source */}
                  <TableCell>{row.source}</TableCell>
                  {/* Note */}
                  <TableCell>
                    <Text> {'-'}</Text>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        page={pageNum}
        rowsPerPage={pageSize}
        count={totalItem}
        onPageChange={(e, page) => {
          setPageNum(page)
          queryServiceInquiryList(pageSize, page)
        }}
        onRowsPerPageChange={(e) => {
          setPageSize(Number(e.target.value))
          setPageNum(0)
          queryServiceInquiryList(Number(e.target.value), 0)
        }}
        labelRowsPerPage={t('common:PaginationSize')}
        labelDisplayedRows={({ from, to, count }) => t('common:Pagination', { from, to, count })}
        component={View}
      />
    </View>

  )
}